import { Injectable } from '@angular/core';
import { Product } from '../models/product.model';
import { ProductListing, ProductListingVariant } from '../models/product-listing.model';

export interface ProductPrice {
  actualPrice: number;
  sellingPrice: number;
}

@Injectable({
  providedIn: 'root'
})
export class PriceService {

  static _getProductPrice(product: Product): ProductPrice {

    const sellingPrice = +product?.price_list?.recommended_offers?.applicable_amount;
    const actualPrice = product?.selling_price ?? 0;

    return ({
      actualPrice,
      sellingPrice
    });
  }

  getProductPrice(product: Product): ProductPrice {

    const sellingPrice = +product?.price_list?.recommended_offers?.applicable_amount;
    const actualPrice = product?.mrp ?? 0;

    return ({
      actualPrice,
      sellingPrice
    });
  }


  getProductListingPrice(variants: ProductListingVariant): ProductPrice {

    const sellingPrice = +variants.price_list?.recommended_offers?.applicable_amount;
    const actualPrice = variants?.mrp ?? 0;

    return ({
      actualPrice,
      sellingPrice
    });
  }


}
